// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3R3rz","calendarButtons":"ClockData_calendarButtons__w4GNn"};